import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionPlanService, UpdateSubscriptionPlanPayload } from '@services/subscription-plan';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useUpdateSubscriptionPlan = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['subscriptionPlans', 'update'],
    mutationFn: async ({ planId, payload }: { planId: string; payload: UpdateSubscriptionPlanPayload }) => {
      return await subscriptionPlanService.update(planId, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscriptionPlans'] });
      toast.success(tActionMessages.subscriptionPlanUpdatedSuccessfully);
    },
    onError: (error: any) => {
      console.error('Update subscription plan error:', error);
      const errorMessage =
        error?.response?.errors?.[0]?.message ||
        error?.message ||
        'Failed to update subscription plan';
      toast.error(errorMessage);
    },
  });
};
